<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" v-if="mode === 'new' || mode === 'edit'">
            <ColorDetailEditor
              ref="colorEditor"
              :mode="mode"
              :isShowProductRelate="mode === 'new' ? false : true"
              v-model="model"
              :isChanged.sync="isPayloadChanged"
            />
            <div class="row">
              <div class="col-md-6">
                <div class="text-left">
                  <div class="button-items">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="onCancel()"
                    >
                      <i
                        class="bx bx-arrow-back font-size-16 align-middle mr-2"
                      ></i>
                      Back
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="text-right">
                  <div class="button-items">
                    <button
                      v-if="isPayloadChanged"
                      type="button"
                      class="btn btn-send-approve"
                      @click="onSubmit"
                    >
                      <i class="bx bx-user-check" />Send to Approve
                    </button>
                    <button
                      type="button"
                      @click="onConfirmReset"
                      class="btn btn-light"
                    >
                      <i class="bx bx-reset font-size-16 align-middle mr-2"></i>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="mode === 'view'">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <button
                    v-show="isShowEditBtn"
                    @click="changeMode('edit')"
                    type="button"
                    class="btn btn-warning waves-effect waves-light"
                  >
                    <i class="mdi mdi-pencil label-icon"></i>
                    Edit Color
                  </button>
                </div>
              </div>
            </div>
            <ColorDetailView v-model="model" />
            <div class="form-group mb-4 text-left">
              <div class="button-items">
                <button type="button" class="btn btn-light" @click="onCancel()">
                  <i
                    class="bx bx-arrow-back font-size-16 align-middle mr-2"
                  ></i>
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import Vue from 'vue'
import vue2Dropzone from 'vue2-dropzone'
import DatePicker from 'vue2-datepicker'
import Swal from 'sweetalert2'

import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import colorService from '@/helpers/service/color-service'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import { OptionDropdownStatus } from '@/helpers/utils/status.js'
import ColorDetailView from '@/components/color/view'
import ColorDetailEditor from '@/components/color/editor'

/**
 * Projects-create component
 */
export default {
  page: {
    title: 'Color',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    ColorDetailView,
    ColorDetailEditor,
  },
  data() {
    return {
      id: '',
      title: 'View',
      mode: 'view',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Color',
          href: '/colors',
        },
        {
          text: 'View',
          active: true,
        },
      ],
      model: {
        id: null,
        display_name: {
          th: '',
          en: '',
        },
        status: StatusEnum.ACTIVE,
        color_code: '#ffffff',
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      isValidate: {
        display_name_th: false,
        display_name_en: false,
        status: false,
      },
      reloadStatusSelector: false,
      optionsStatus: [],
      isPayloadChanged: false,
      messageAlertConfirm: '',
    }
  },
  computed: {
    isShowEditBtn() {
      return !(
        this.model.status === 'Delete' || this.model.status === 'Pending'
      )
    },
  },
  created() {
    if (this.$route.params.id == 'new') {
      this.mode = 'new'
      this.title = 'New Color'
      this.items[2].text = 'New'
    } else {
      this.title = 'Detail'
      this.items[2].text = 'Color Detail'
      this.id = this.$route.params.id
    }
    if (this.$route.query.mode) {
      this.title = 'Edit Color'
      this.items[2].text = 'Edit'
      this.mode = this.$route.query.mode
    }
  },
  mounted() {
    this.optionsStatus = OptionDropdownStatus
    if (this.mode !== 'new') {
      this.getDetail()
    }
  },
  methods: {
    async getColorProductSku() {
      var result = await colorService.getColorProductSkuListAsync(this.id)
      if (result.status === 200) {
        console.log(result.data.skus)
        var countStatusProductDelete = 0
        var countStatusProductAnother = 0
        result.data.skus.forEach(element => {
          if (element.inventory_status === 'Delete') {
            countStatusProductDelete++
          } else {
            countStatusProductAnother++
          }
        })

        if (result.data.skus.length === 0) {
          this.messageAlertConfirm = 'ต้องการแก้ไขข้อมูลใช่หรือไม่'
        } else {
          if (countStatusProductDelete === result.data.skus.length) {
            this.messageAlertConfirm =
              'มีสินค้าสถานะพร้อมขายอยู่ในแบรนด์นี้ ต้องการแก้ไขข้อมูลใช่หรือไม่'
          } else if (
            countStatusProductAnother === result.data.skus.length ||
            (countStatusProductAnother !== 0 && countStatusProductDelete !== 0)
          ) {
            this.messageAlertConfirm =
              'มีสินค้าสถานะพร้อมขายอยู่ในแบรนด์นี้ ต้องการแก้ไขข้อมูลใช่หรือไม่'
          } else {
            this.messageAlertConfirm = 'ต้องการแก้ไขข้อมูลใช่หรือไม่'
          }
        }
      }
    },
    async getDetail() {
      let result = await colorService.getColorMasterDetailAsync(this.id)
      if (result.status === 200) {
        this.model = result.data
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    onCancel() {
      this.$router.push({
        path: '/colors',
      })
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            if (this.mode === 'new') {
              this.model.display_name.en = ''
              this.model.display_name.th = ''
              this.model.status = StatusEnum.ACTIVE
              this.model.color_code = '#ffffff'

              this.$refs.colorEditor.$refs.addDataForm.reset()
            } else {
              this.getDetail()
            }
          }
        })
    },
    async onSubmit() {
      if (
        this.model.status === '' ||
        this.model.status === undefined ||
        this.model.status === null
      ) {
        this.isValidate.status = true
        return
      }
      if (this.mode === 'new') {
        await this.onSaveCreate()
      } else {
        this.$utils
          .confirmAlertDisplay(this.messageAlertConfirm, '')
          .then(result => {
            if (result) this.onSave()
          })
      }
    },
    changeMode(_mode) {
      if (_mode == 'edit') {
        this.mode = 'edit'
        this.title = 'Edit'
        this.items[2].text = 'Edit'
        this.getDetail()
        this.getColorProductSku()
      }
    },
    async onSave() {
      this.$refs.colorEditor.$refs.addDataForm
        .validate()
        .then(async response => {
          if (response) {
            this.model.color_code =
              this.model.color_code.hex === undefined
                ? this.model.color_code
                : this.model.color_code.hex
            this.removeLastAndFirstSpacesFromString()
            let result = await colorService.updateAllColorApprovalAsync(
              this.id,
              this.model
            )
            if (result.status && result.status === 204) {
              this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
              this.$router.push({
                path: '/colors',
              })
            } else if (result.status === 201) {
              let approval_document = result.data.approval_documents[0]

              //    this.$utils.notificationAck(
              //   'success',
              //   'เพิ่มข้อมูลสำเร็จ',
              //   `สร้างเอกสาร Request เลขที่ ${result.data.id} <br> เอกสารขออนุมัติ ${approval_document.rule_id}(${approval_document.rule_name.th}) เลขที่ <a href='/requests/${result.data.id}/approvals/${approval_document.approval_document_id}' >${approval_document.approval_document_id} </a> สำเร็จ`
              // )
              this.$utils.notificationAck(
                'success',
                'แก้ไขข้อมูลสำเร็จ',
                `สร้างเอกสารเลขที่ <a href='/requests/${result.data.id}/approvals/${approval_document.approval_document_id}' >${result.data.id}</a>  <br> ขออนุมัติ${approval_document.rule_name.th} (${approval_document.rule_id}) สำเร็จ`
              )
            } else if (
              (result.status && result.status !== 500) ||
              (result.response && result.response.status !== 500)
            ) {
              this.$utils.notification(
                'error',
                result.response.data.message,
                2000
              )
            }
          }
        })
    },
    async onSaveCreate() {
      this.$refs.colorEditor.$refs.addDataForm
        .validate()
        .then(async response => {
          if (response) {
            this.model.color_code =
              this.model.color_code.hex === undefined
                ? this.model.color_code
                : this.model.color_code.hex
            this.removeLastAndFirstSpacesFromString()
            let result = await colorService.createColorMasterAsync(this.model)
            if (result.status === 201) {
              console.log(result.data)
              if (result.data.approval_documents !== null) {
                let approval_document = result.data.approval_documents[0]
                // this.$utils.notificationAck(
                //   'success',
                //   'เพิ่มข้อมูลสำเร็จ',
                //   `สร้างเอกสาร Request เลขที่ ${result.data.id} <br> เอกสารขออนุมัติ ${approval_document.rule_id}(${approval_document.rule_name.th}) เลขที่ <a href='/requests/${result.data.id}/approvals/${approval_document.approval_document_id}' >${approval_document.approval_document_id} </a> สำเร็จ`
                // )
                this.$utils.notificationAck(
                  'success',
                  'เพิ่มข้อมูลสำเร็จ',
                  `สร้างเอกสารเลขที่ <a href='/requests/${result.data.id}/approvals/${approval_document.approval_document_id}' >${result.data.id}</a>  <br> ขออนุมัติ${approval_document.rule_name.th} (${approval_document.rule_id}) สำเร็จ`
                )
                this.$router.push({
                  path: '/colors',
                })
              } else {
                this.$utils.notification('success', 'เพิ่มข้อมูลสำเร็จ')
                this.$router.push({
                  path: '/colors',
                })
              }
            } else if (
              (result.status && result.status !== 500) ||
              (result.response && result.response.status !== 500)
            ) {
              this.$utils.notification(
                'error',
                result.response.data.message,
                5000
              )
            }
          }
        })
    },
    removeLastAndFirstSpacesFromString() {
      this.model.display_name = {
        en: this.model.display_name.en.trim(),
        th: this.model.display_name.th.trim(),
      }
    },
  },
}
</script>
